import { Noise } from 'noisejs';

import { GetBy } from "../_app/cuchillo/core/Element";
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { WaveCircle } from './WaveCircle';

export default class Wave {
    container;
    path;
    speed = 0;
    noise;
    width = 0;
    height = 0;
    options = {
        frequency: Math.random() * (0.008 - 0.001) + 0.001,
        amplitude: Math.random() * (35 - 25) + 25,
    };

    constructor(__svg, __opts = {}) {
        this.container = __svg;
        this.path = GetBy.selector('path', this.container)[0];

        this.options = {
            ...__opts,
            ...this.options,
        }

        this.noise = new Noise(Math.random());

        this.resize();
        this.generateSmoothWavePath();
    }

    setupAttributes() {
        this.container.setAttribute('viewBox', `0 0 ${this.width} ${this.height}`);
        this.container.setAttribute('width', this.width);
        this.container.setAttribute('height', this.height);
    }

    generateSmoothWavePath() {
        let pathData = `M 0 ${this.height / 2}`;

        for (let x = 0; x < this.width; x++) {
            const noiseValue = this.noise.perlin2(x * .0055, this.speed * 0.04 + Scroll.speed * .08);
            const variableAmplitude = this.options.amplitude * (0.5 + noiseValue);

            const y = variableAmplitude * Math.sin(this.options.frequency * x + this.speed) + this.height / 2;
            pathData += `L ${x} ${y}`;
        }

        pathData += `L ${this.width} ${this.height} L 0 ${this.height} Z`;
        this.path.setAttribute('d', pathData);
    }

    loop(__t) {
        this.speed = __t * .01;
        this.generateSmoothWavePath();
    }

    dispose() {
        this.container = null;
        this.path = null;
    }

    resize() {
        const { height, width } = this.container.getBoundingClientRect();

        this.height = height;
        this.width = width;

        this.setupAttributes();
    }
}
